import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Permission } from '@/types/permission'

export function getPermissions(): Promise<AxiosResponse<Permission[]>> {
  return instance.get(`/iam/permission`)
}
